import type { FaireProductEntity } from "../../entity_types/product";

export const p_vdsscwka4e: FaireProductEntity = {
  token: "p_vdsscwka4e",
  type: "product",
  name: "Spooky Gel Dumplings",
  brandToken: "b_9v893wm2yy",
  brandName: "Golden Parrot",
  imageUrl:
    "https://cdn.faire.com/fastly/2146e95c8eaa0018f506d40aa64e2e5768545193e62858eb568ae565b6c9e920.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31253d493fcc1653b3a6af01a20d80f06ec5448cf8daf9710e40c5edab4ee716.jpeg",
    "https://cdn.faire.com/fastly/e9aa61abdf10a6e8378600cf21f360aac1670f777dc9e060ea6cde28f78baef5.jpeg",
  ],
  priceDollars: 9.99,
  description:
    "Each comes in a Halloween-themed steamer case, but which creepy critter you get? That’s a mystery! Collect all 12! \nGel-filled not the thin glitter style.\n\n\n\n3.3 inches each \n\n8 ounces each \n\nAge Grade: 5+\n\nSafety Information:\n\n * Choking Hazard – Small Parts \n * Not for children under 3 years \n * Non-food item; do not eat \n * Keep away from pets \n * Inspect regularly and discontinue use if damaged \nProduct contains a soft sensory filling. If punctured, discard immediately and keep contents away from children and pets.\n\n\n",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:38.024Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
